import "../assets/index-61b63a8f.css";
import { n as a } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const t = {
  name: "NcProgressBar",
  props: {
    /**
     * An integer between 1 and 100
     */
    value: {
      type: Number,
      default: 0,
      validator(r) {
        return r >= 0 && r <= 100;
      }
    },
    /**
     * Determines the height of the progressbar.
     * Possible values:
     * - 'small' (default)
     * - 'medium'
     */
    size: {
      type: String,
      default: "small",
      validator(r) {
        return ["small", "medium"].indexOf(r) !== -1;
      }
    },
    /**
     * Applies an error color to the progressbar if true.
     */
    error: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    height() {
      return this.size === "small" ? "4px" : "6px";
    }
  }
};
var o = function() {
  var e = this, s = e._self._c;
  return s("progress", { staticClass: "progress-bar vue", class: { "progress-bar--error": e.error }, style: { "--progress-bar-height": e.height }, attrs: { max: "100" }, domProps: { value: e.value } });
}, l = [], n = /* @__PURE__ */ a(
  t,
  o,
  l,
  !1,
  null,
  "b171a315",
  null,
  null
);
const p = n.exports;
export {
  p as default
};
